import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFirmAccountAddOnMutationVariables = Types.Exact<{
  input: Types.CreateFirmAccountAddOnInput;
}>;


export type CreateFirmAccountAddOnMutation = { __typename?: 'Mutation', createFirmAccountAddOn: { __typename?: 'FirmAccountAddOnEntity', id: string, subscriptionStatus?: Types.StripeSubscriptionStatus | null, subscriptionCancelAtPeriodEnd?: boolean | null } };

export type UpdateFirmAccountAddOnMutationVariables = Types.Exact<{
  input: Types.UpdateFirmAccountAddOnInput;
}>;


export type UpdateFirmAccountAddOnMutation = { __typename?: 'Mutation', updateFirmAccountAddOn: { __typename?: 'FirmAccountAddOnEntity', id: string, subscriptionStatus?: Types.StripeSubscriptionStatus | null, subscriptionCancelAtPeriodEnd?: boolean | null } };

export type DeleteFirmAccountAddOnMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteFirmAccountAddOnMutation = { __typename?: 'Mutation', deleteFirmAccountAddOn: boolean };


export const CreateFirmAccountAddOnDocument = gql`
    mutation CreateFirmAccountAddOn($input: CreateFirmAccountAddOnInput!) {
  createFirmAccountAddOn(input: $input) {
    id
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
  }
}
    `;
export type CreateFirmAccountAddOnMutationFn = Apollo.MutationFunction<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>;

/**
 * __useCreateFirmAccountAddOnMutation__
 *
 * To run a mutation, you first call `useCreateFirmAccountAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFirmAccountAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFirmAccountAddOnMutation, { data, loading, error }] = useCreateFirmAccountAddOnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFirmAccountAddOnMutation(baseOptions?: Apollo.MutationHookOptions<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>(CreateFirmAccountAddOnDocument, options);
      }
export type CreateFirmAccountAddOnMutationHookResult = ReturnType<typeof useCreateFirmAccountAddOnMutation>;
export type CreateFirmAccountAddOnMutationResult = Apollo.MutationResult<CreateFirmAccountAddOnMutation>;
export type CreateFirmAccountAddOnMutationOptions = Apollo.BaseMutationOptions<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>;
export const UpdateFirmAccountAddOnDocument = gql`
    mutation UpdateFirmAccountAddOn($input: UpdateFirmAccountAddOnInput!) {
  updateFirmAccountAddOn(input: $input) {
    id
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
  }
}
    `;
export type UpdateFirmAccountAddOnMutationFn = Apollo.MutationFunction<UpdateFirmAccountAddOnMutation, UpdateFirmAccountAddOnMutationVariables>;

/**
 * __useUpdateFirmAccountAddOnMutation__
 *
 * To run a mutation, you first call `useUpdateFirmAccountAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFirmAccountAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFirmAccountAddOnMutation, { data, loading, error }] = useUpdateFirmAccountAddOnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFirmAccountAddOnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFirmAccountAddOnMutation, UpdateFirmAccountAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFirmAccountAddOnMutation, UpdateFirmAccountAddOnMutationVariables>(UpdateFirmAccountAddOnDocument, options);
      }
export type UpdateFirmAccountAddOnMutationHookResult = ReturnType<typeof useUpdateFirmAccountAddOnMutation>;
export type UpdateFirmAccountAddOnMutationResult = Apollo.MutationResult<UpdateFirmAccountAddOnMutation>;
export type UpdateFirmAccountAddOnMutationOptions = Apollo.BaseMutationOptions<UpdateFirmAccountAddOnMutation, UpdateFirmAccountAddOnMutationVariables>;
export const DeleteFirmAccountAddOnDocument = gql`
    mutation DeleteFirmAccountAddOn($id: String!) {
  deleteFirmAccountAddOn(id: $id)
}
    `;
export type DeleteFirmAccountAddOnMutationFn = Apollo.MutationFunction<DeleteFirmAccountAddOnMutation, DeleteFirmAccountAddOnMutationVariables>;

/**
 * __useDeleteFirmAccountAddOnMutation__
 *
 * To run a mutation, you first call `useDeleteFirmAccountAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFirmAccountAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFirmAccountAddOnMutation, { data, loading, error }] = useDeleteFirmAccountAddOnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFirmAccountAddOnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFirmAccountAddOnMutation, DeleteFirmAccountAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFirmAccountAddOnMutation, DeleteFirmAccountAddOnMutationVariables>(DeleteFirmAccountAddOnDocument, options);
      }
export type DeleteFirmAccountAddOnMutationHookResult = ReturnType<typeof useDeleteFirmAccountAddOnMutation>;
export type DeleteFirmAccountAddOnMutationResult = Apollo.MutationResult<DeleteFirmAccountAddOnMutation>;
export type DeleteFirmAccountAddOnMutationOptions = Apollo.BaseMutationOptions<DeleteFirmAccountAddOnMutation, DeleteFirmAccountAddOnMutationVariables>;
export const namedOperations = {
  Mutation: {
    CreateFirmAccountAddOn: 'CreateFirmAccountAddOn',
    UpdateFirmAccountAddOn: 'UpdateFirmAccountAddOn',
    DeleteFirmAccountAddOn: 'DeleteFirmAccountAddOn'
  }
}